import React, { useState } from 'react';
import { ReactComponent as UploadedFile } from 'assets/icons/uploaded-file.gov.svg';
import { ReactComponent as UploadedFileError } from 'assets/icons/uploaded-file-error.svg';
import { ReactComponent as DownloadBlack } from 'assets/icons/download-black.svg';
import { downloadUploadedFile } from 'store/forms/actions';
import { useDispatch } from 'react-redux';
import { ReactComponent as Bin } from 'assets/icons/bin.svg';
import { Progress, Tooltip } from 'components';

const File = ({ error, file, handleDeleteDocument, percent, view }) => {
  const dispatch = useDispatch();
  const [tooltipVisible, setTooltipVisible] = useState('');
  const isVisible = tooltipVisible === 'file-name-hover';
  const onOpenChange = v => setTooltipVisible(v ? 'file-name-hover' : '');

  return (
    <div
      onClick={event => {
        event.stopPropagation();
        event.preventDefault();
      }}
      className={`custom-drag-upload-static__uploading-progress ${
        error && 'custom-drag-upload-static__uploading-error'
      }`}
    >
      <div className="d-flex justify-content-between">
        <div className="d-flex w-100">
          {/* {error ? <UploadedFileError /> : <UploadedFile />} */}
          <div className="w-100 file-details-container">
            {error ? (
              <div className="file-error">
                <div>{file.description}</div>
                {file.fileLimit && (
                  <div>The max file size is {file.fileLimit}MB.</div>
                )}
                <span>{file.name}</span>
              </div>
            ) : (
              <>
                <Tooltip
                  key={file.id}
                  title={file.name}
                  visible={isVisible}
                  onOpenChange={onOpenChange}
                >
                  <div className="filename">{file.name}</div>
                </Tooltip>
                <div style={{display: 'flex', justifyContent: 'space-between', cursor: 'auto'}}>
                    <div className="filesize" >
                      {Math.round(file.size / 1000)} KB
                    </div>
                    {view && 
                      <div 
                        style={{cursor: 'pointer'}}
                        className='open-download-link'
                        onClick={() => dispatch(downloadUploadedFile(file))}
                      >
                        <span>Άνοιγμα</span> <DownloadBlack/>
                      </div>
                    }
                </div>
                <div className="d-flex" style={{cursor: 'auto'}}>
                  <Progress percent={percent || 100} showInfo={false} />
                  {/* <div className="ml-1 file-percent">{percent || 100}%</div> */}
                </div>
              </>
            )}
          </div>
        </div>
        {!view && <Bin
          onClick={event => handleDeleteDocument(event, file)}
          color={error ? '#B42318' : '#667085'}
          className="remove-file"
        />}
      </div>
    </div>
  );
};

export default File;
